export const NAV = {
  sidebar: 'site-sidebar',
  toggleSidebar: 'site-sidebar-toggle',
  registerLink: 'site-register-link',
  loginLink: 'site-login-link',
  searchInput: 'site-search-input',
  logo: 'site-logo',
  logout: 'site-logout-button',
};

export const HERO = {
  video: 'hero-video',
  primaryCta: 'hero-primary-cta',
  secondaryCta: 'hero-secondary-cta',
};

export const CONTESTANT = {
  card: 'contestant-card',
  voteButton: 'contestant-vote-button',
};

export const APPLY = {
  form: 'apply-form',
  submit: 'apply-submit-button',
};

export const CONTACT_FORM = {
  form: 'contact-form',
  submit: 'contact-submit-button',
};
